import React from "react";
import { serviceActions } from "../assets/serviciosDetalle";

export default function ProductionCta({ service }) {
    const emailLabel = service.contactEmail || serviceActions.emailLabel;
    const emailHref = service.contactEmail
        ? `mailto:${service.contactEmail}`
        : serviceActions.email;

    return (
        <section className="production-cta" id="contacto">
            <div className="production-inner">
                <h2>¿Tenés un <span>evento o proyecto</span> en mente?</h2>
                <p>{service.ctaText}</p>
                <div className="production-cta-actions">
                    <a href={serviceActions.whatsapp}>Contactar por WhatsApp</a>
                    <a href={emailHref}>{emailLabel}</a>
                </div>
            </div>
        </section>
    );
}
